module.exports = __webpack_public_path__ + "img/papelera.61d8e7ef.png";